var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgThailand = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 55.68 38.88",
    style: {
      enableBackground: "new 0 0 55.68 38.88"
    },
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M3.27,0.24h49.13c1.67,0,3.03,1.36,3.03,3.03v32.33c0,1.67-1.37,3.03-3.03,3.03H3.27 c-1.67,0-3.03-1.37-3.03-3.03V3.27C0.24,1.6,1.6,0.24,3.27,0.24L3.27,0.24z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0.24,5.59 55.44,5.59 55.44,33.29 0.24,33.29 0.24,5.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "0.24,12.52 55.44,12.52 55.44,26.36 0.24,26.36 0.24,12.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M3.27,0.24h49.13c1.67,0,3.03,1.36,3.03,3.03v32.33c0,1.67-1.37,3.03-3.03,3.03H3.27 c-1.67,0-3.03-1.37-3.03-3.03V3.27C0.24,1.6,1.6,0.24,3.27,0.24L3.27,0.24z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgThailand);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/thailand.f6a5000623973205fb3800547323c18c.svg";